module.exports = __webpack_public_path__ + "static/media/PDF.c92bf7c5.ico";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/PDF.ico
// module id = 141
// module chunks = 0